/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The shared authorization server of a user session issuer, which an external platform exchanges its workload token at.
 */
export type WorkloadTokenEndpoint = {
  /**
   * The authorization server's issuer identifier, as its RFC 8414 metadata publishes it.
   */
  issuer: string;
  /**
   * The host MCP servers are served on, which a platform calls with the tokens it is issued.
   */
  mcpHost: string;
  /**
   * The owning project id; empty for an organization-level issuer.
   */
  projectId: string;
  /**
   * The owning project name; empty for an organization-level issuer.
   */
  projectName: string;
  /**
   * The authorization server's token endpoint.
   */
  tokenEndpoint: string;
  /**
   * The user session issuer id.
   */
  userSessionIssuerId: string;
  /**
   * The user session issuer slug.
   */
  userSessionIssuerSlug: string;
};

/** @internal */
export const WorkloadTokenEndpoint$inboundSchema: z.ZodMiniType<
  WorkloadTokenEndpoint,
  unknown
> = z.pipe(
  z.object({
    issuer: z.string(),
    mcp_host: z.string(),
    project_id: z.string(),
    project_name: z.string(),
    token_endpoint: z.string(),
    user_session_issuer_id: z.string(),
    user_session_issuer_slug: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "mcp_host": "mcpHost",
      "project_id": "projectId",
      "project_name": "projectName",
      "token_endpoint": "tokenEndpoint",
      "user_session_issuer_id": "userSessionIssuerId",
      "user_session_issuer_slug": "userSessionIssuerSlug",
    });
  }),
);

export function workloadTokenEndpointFromJSON(
  jsonString: string,
): SafeParseResult<WorkloadTokenEndpoint, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WorkloadTokenEndpoint$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WorkloadTokenEndpoint' from JSON`,
  );
}
